import { fetchOverallStatus } from "../network/OverallStatusNetworkAPI";

export const OverallStatusReducer = (state, action) => {
  switch (action.type) {
    case "LOAD_VIEW":
      const { filter, dispatcher, baseUrl } = action.data;
      fetchOverallStatus(filter, dispatcher, baseUrl);
      return state;
    case "RECEIVE_INDUCT_DATA":
      return { ...state, ...action.data };
    case "RECEIVE_STOW_DATA":
      return { ...state, ...action.data };
    case "RECEIVE_RSWS_DATA":
      return { ...state, ...action.data };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/overallstatus/reducers/OverallStatusReducer.js